export default __webpack_public_path__ + "static/media/xp-waze.2506ac94.svg";